import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  return (
    <>
      {/* Blur-to-clear overlay on every page load */}
      <motion.div
        key={window.location.pathname}
        initial={{ backdropFilter: 'blur(20px)', opacity: 1 }}
        animate={{ backdropFilter: 'blur(0px)', opacity: 0 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 999,
          pointerEvents: 'none',
          backdropFilter: 'blur(20px)',
          backgroundColor: 'rgba(254, 232, 192, 0.35)'
        }}
      />
      {children}
    </>
  );
};

export default PageTransition;
